export default "__VITE_PUBLIC_ASSET__cf2d193a__"